import { CHAIN_ID_KEY } from '../constants'

export default () => {
  return localStorage.getItem(CHAIN_ID_KEY)
}
